import { Component, OnInit } from "@angular/core";
import { TransactionsService } from "../services/transactions.service";
import { ClientTxnReq, ClientTxnRes } from "../model/clientTxnRequest";
import { TokenService } from "../../../core/tokenManagement/token.service";
import { ErrorHandlers } from "../../../core/helpers/errorhandlers";
import { Pagination } from "../../../shared/models/response/pagination";
import { SharedService } from "../../../shared/services/shared.service";
import { Angular5Csv } from "angular5-csv/dist/Angular5-csv";
import { DataStore } from "../../../shared/data-store.service";

@Component({
  selector: "app-settlement",
  templateUrl: "./settlement.component.html",
  styleUrls: ["./settlement.component.css"],
})
export class SettlementComponent implements OnInit {
  showFilter: boolean = false;
  txnRequest = new ClientTxnReq();
  txnResponse: ClientTxnRes[] = [];
  // txnResponse = new ClientTxnRes();
  clientId: string;
  defaultStart = new Date().getTime() - 604800000;
  start = new Date(this.defaultStart);
  stop = new Date();
  isLoading: boolean = false;
  itemPerPage = 10;
  paginationItemsPerPage = [5, 10, 20, 50, 100];
  pagination = new Pagination();
  perms = this.sharedservice.permissions;

  constructor(
    private transservice: TransactionsService,
    private tokenservice: TokenService,
    private errorhandler: ErrorHandlers,
    private sharedservice: SharedService,
    private data: DataStore
  ) {}
  ngOnInit() {
    this.getClient();
  }

  getClient() {
    this.sharedservice.activatePermmisions();
    let data: any = this.tokenservice.getclientID();
    this.clientId = data.clientID;
    this.searchByQuery();
  }

  closeAndClearFilterForm() {
    this.txnRequest = new ClientTxnReq();
    this.start = new Date();
    this.stop = new Date();
    this.showFilter = false;
    this.searchByQuery();
  }

  getClientTransactions(txnRequest, clientId) {
    this.showFilter = false;
    this.isLoading = true;
    this.transservice.getSettlementData(txnRequest, clientId).subscribe(
      (data: any) => {
        this.txnResponse = data["data"];
        this.pagination = data;
        this.isLoading = false;
      },
      (error) => {
        this.errorhandler.customclienterrors(
          "Failed",
          error.status,
          error.error.responseMessage
        );
        this.isLoading = false;
      }
    );
  }

  searchByQuery() {
    this.showFilter = false;
    let st = new Date(this.start).getTime() + 86400000; // add extra day to the date selected because of time xone issue from date picker
    let en = new Date(this.stop).getTime() + 86400000;
    let _start = this.start;
    let _stop = this.stop;

    this.txnRequest.startDate = _start.toISOString().substr(0, 10);
    this.txnRequest.endDate = _stop.toISOString().substr(0, 10);

    // this.txnRequest.startDate = "2020-01-01";
    // this.txnRequest.endDate = "2020-01-03";

    this.getClientTransactions(this.txnRequest, this.clientId);
  }

  //  request by pagination
  requestPageSize(value) {
    this.txnRequest.pageSize = value.pageSize;
    this.txnRequest.pageIndex = value.pageIndex;
    this.searchByQuery();
  }

  async exportCSV() {
    var options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      nullToEmptyString: false,
      // showTitle: true,
      useBom: false,
      noDownload: false,
      headers: [
        "Settlement Date",
        "Settlement Reference",
        "Status",
        "Settlement Amount",
        "Settlement Currency",
        "Last Updated",
        "Bank Account Number",
        "Bank Code",
        "Narration",
      ],
    };
    this.txnRequest.pageSize = this.pagination.totalElements;
    this.txnRequest.pageIndex = 0;
    this.showFilter = false;
    this.isLoading = true;
    this.transservice
      .getSettlementData(this.txnRequest, this.clientId)
      .subscribe(
        async (data: any) => {
          let dataToExport = [];
          dataToExport = await this.sortResponse(data["data"]);
          this.txnResponse = data["data"];
          this.pagination = await data;
          new Angular5Csv(dataToExport, "Settlement", options);
          this.isLoading = false;
        },
        (error) => {
          this.errorhandler.customclienterrors(
            "Failed",
            error.status,
            error.error.responseMessage
          );
          this.isLoading = false;
        }
      );
  }

  sortResponse(rex) {
    let newArray = [];
    for (let a = 0; a < rex.length; a++) {
      newArray.push([]);
      newArray[a]["createdAt"] = rex[a]["createdAt"];
      newArray[a]["processingReference"] = rex[a]["processingReference"];
      newArray[a]["processingStatus"] = rex[a]["processingStatus"];
      newArray[a]["transactionAmount"] = rex[a]["transactionAmount"];
      newArray[a]["transactionCurrency"] = rex[a]["transactionCurrency"];
      newArray[a]["lastUpdatedAt"] = rex[a]["lastUpdatedAt"];
      newArray[a]["bankAccountNumber"] = rex[a]["bankAccountNumber"]
        ? rex[a]["bankAccountNumber"]
        : "Not Available";
      newArray[a]["bankAccountCode"] = rex[a]["bankAccountCode"]
        ? rex[a]["bankAccountCode"]
        : "Not Available";
      newArray[a]["narration"] = rex[a]["narration"]
        ? rex[a]["narration"]
        : "Not Available";
    }
    return newArray;
  }
}
